import { ProviderOnlineStatus } from "@libs/gateways/bhb/bhbGateway.dtos.ts";
import { BhbProvider } from "@stores/bhb/models/BhbProvider.ts";

import { BhbProvidersOnlineFilter } from "../bhb-configuration-card/providers-form/BhbProvidersCard.types.ts";
import { BhbAvailability } from "../bhb-configuration-card/providers-form/BhbProvidersFilter.tsx";

export const filterData = (
  provider: BhbProvider,
  filters: BhbProvidersOnlineFilter | undefined
): boolean => {
  if (!filters) {
    return true;
  }

  const { search, onlineAvailability, providers, appointmentTypes } = filters;

  if (
    search &&
    !(
      provider.displayName.toLowerCase().includes(search.toLowerCase()) ||
      provider.firstName.toLowerCase().includes(search.toLowerCase()) ||
      provider.lastName.toLowerCase().includes(search.toLowerCase())
    )
  ) {
    return false;
  }

  if (onlineAvailability && onlineAvailability.length > 0) {
    const statusMap: Record<BhbAvailability, ProviderOnlineStatus> = {
      ShowAndBook: ProviderOnlineStatus.YES,
      ShowAndCall: ProviderOnlineStatus.CALL,
      DontShow: ProviderOnlineStatus.NO
    };

    const selectedStatus = onlineAvailability.find(
      (status: BhbAvailability) =>
        provider.providerOnlineStatus === statusMap[status]
    );
    if (!selectedStatus) {
      return false;
    }
  }

  if (providers && providers.length > 0 && !providers.includes(provider.id)) {
    return false;
  }

  if (
    appointmentTypes &&
    appointmentTypes.length > 0 &&
    !appointmentTypes.some(type =>
      provider.appointmentTypes.some(appType => appType.id === type)
    )
  ) {
    return false;
  }

  return true;
};
